import { apiWithTag } from "../emptySplitApi";
import { ApiAddWallet, ApiAllowAirdropRequest, ApiMintNFT, ApiWallet, ApiWalletPagable, PagedWalletRequest } from "./type-api";


export const usersApi = apiWithTag.injectEndpoints({

    endpoints: (builder) => ({

        mintNFT: builder.mutation<void, ApiMintNFT>({
            query: ({ userId, walletId }) => ({
                method: 'POST',
                subDomain: 'auth',
                url: `v1/users/${userId}/wallets/${walletId}/nft-identity-token`,
                body: {},
                invalidatesTags: ['Users']

            }),
        }),
        addWallet: builder.mutation<void, ApiAddWallet>({
            query: ({ userId, ...body }) => ({
                method: 'POST',
                subDomain: 'auth',
                url: `v1/users/${userId}/wallets`,
                body: { ...body },
                invalidatesTags: ['Users']

            }),
        }),
        wallets: builder.query<ApiWalletPagable, PagedWalletRequest>({
            query: ({ userId, ...request }) => ({
                method: 'GET',
                url: `v1/users/${userId}/wallets`,
                params: request,
                subDomain: 'auth',
            }),
            providesTags: ['Users']
        }),
        walletsList: builder.query<ApiWallet[], { userId: string }>({
            query: ({ userId }) => ({
                method: 'GET',
                url: `v1/users/${userId}/wallets/all`,
                subDomain: 'auth',
            }),
            providesTags: ['Users']
        }),
        updateAllowAirdrop: builder.mutation<void, ApiAllowAirdropRequest>({
            query: ({ userId, walletId, ...body }) => ({
                method: 'PUT',
                url: `v1/users/${userId}/wallets/${walletId}`,
                subDomain: 'auth',
                body: { ...body }
            }),
            invalidatesTags: ['Users']
        }),

    })
})

export const {
    useMintNFTMutation,
    useAddWalletMutation,
    useWalletsQuery,
    useWalletsListQuery,
    useUpdateAllowAirdropMutation

} = usersApi;